import {  ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ViewRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { FormConfig } from 'src/app/interfaces/formconfig';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { PermissionServices } from 'src/app/services/permission.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { FastFilter } from '../gridview/gridview.component';
import { GridViewDataSource } from '../gridview/gridview.datasource';
import { ProdutoKitComponent} from '../produtos/produto-kit/produto-kit.component'
import { ProdutoInsertEditFormComponent } from './produto-insert-edit-form/produto-insert-edit-form.component';

@Component({
    selector: 'app-produtos',
    templateUrl: './produtos.component.html',
    styleUrls: ['./produtos.component.scss'],
    standalone: false
})
export class ProdutosComponent implements OnInit {
  
  table_name:string;
  entityDesc:string;
  title:string = "NAME";
  img:string = "IMAGE";
  pk:string ="CODEPRODUCT"
  options:Object[] = [];

 
  

  config:{columnName:string, fontName:string, fontSize:string, fontWeight:string, row:number,column:number, descName:string, fontColor:string}[] = [
    {
      columnName:"ACTIVE",
      fontName:"Arial, Helvetica, sans-serif",
      fontWeight:"bold",
      row:1,
      column:2,
      fontSize:"20px",
      descName:"Ativo",
      fontColor: "red"
  },
  {
  columnName:"IDCONF",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:3,
  fontSize:"14px",
  descName:"Id. Configuração",
  fontColor: "blue"
},
{
  columnName:"CODEPRODUCT",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:5,
  fontSize:"14px",
  descName:"Cód. Produto",
  fontColor: "blue"
},
{
  columnName:"CODECONTRACT",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:3,
  fontSize:"14px",
  descName:"Cód. Contrato",
  fontColor: "blue"
},
{
  columnName:"NAME",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:3,
  fontSize:"14px",
  descName:"Nome do Produto",
  fontColor: "blue"
},
,
{
  columnName:"FK_MKTPPRODUCTS_MKTPCONTRACT->CONTRACTNAME",
  fontName:"Arial, Helvetica, sans-serif",
  fontWeight:"bold",
  row:1,
  column:3,
  fontSize:"14px",
  descName:"Nome do Contrato",
  fontColor: "blue"
}
]
  
  integrationRow= {};
  editface = false;
  row:CardView;
  columns = [{name:"CODEPRODUCT", desc:"Cód. Produto"},{name:"NAME", desc:"Nome do Produto"},
  {name:"CODECONTRACT", desc:"Cód. Contrato"},{name:"FK_MKTPPRODUCTS_MKTPCONTRACT->CONTRACTNAME", desc:"Nome do Contrato"}];
  constructor(private http:HTTPService,private routerParam:ActivatedRoute, private cd:ChangeDetectorRef,
    private dialogServices:DialogService,private ap:PermissionServices, private us:UserAuthenticationServices) {

    this.table_name = this.routerParam.snapshot.data["table_name"];
    this.entityDesc = this.routerParam.snapshot.data["entityDesc"];
    
   }

  async ngOnInit() {
    let ob= {
        desc: 'Formação de Kit',
        icon: 'category',
        component: ProdutoKitComponent,
        type:"component"
    }

    if( this.ap.checkPermissionSession('MKTPKIT','edit')){
      this.options.push(ob);
    }
    

    let ob2= {
      desc: 'Editar produto',
      icon: 'edit',
      component: ProdutoInsertEditFormComponent,
      type:"component",
      action:this.openEditDialog
    }
  
    if( this.ap.checkPermissionSession('MKTPPRODUCTS','edit')){
      this.options.push(ob2);
    }
  }

  ngOnDestroy(){
    this.cd.detach();
  }

  clickedRow(row:CardView){
    this.row = row;
    setTimeout(()=>{
      this.editface = true;

      setTimeout(() => {
        if (this.cd !== null && this.cd !== undefined &&
          !(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
        }, 250);
      
    },700)
    
  }

  getData(item){
    let json:Object[] = [];
    
    if ( item['linha'] ){
      if ( item['linha']['MARKEPLACES'] ){
          let marketplaces =JSON.parse( item['linha']['MARKEPLACES']);
          if ( marketplaces ){
            let mktp:Object[] = marketplaces['DATA'];
            json = mktp;
          }
      }
    }
     
    return json;
  }


  
  trackDataItem(index: number, item: Object) {
    return item['logo'];
  }

  openEditDialog=(evento:string, userConfig:Object, row:Object):void=>{
    
    let ob = {
      entityName: this.table_name,
      rows: 1,
      showPresentation: true,
      showRelationshipData: false,
      showRelationship: true,
      fetchSize: 0,
      condition: "0=1",
    };

    if ( evento=='editando'){
      if ( this.us.getSystemPreferences('temapi.use.jdbc.connection').value=="true"){
        let condition = `this.CODECONTRACT=${row['CODECONTRACT']} and this.CODEPRODUCT=${row['CODEPRODUCT']}`
        ob['condition'] = condition;
      }else{
        let condition = `codecontract=${row['CODECONTRACT']} and codeproduct=${row['CODEPRODUCT']}`
        ob['condition'] = condition;
      }
      
    }

    this.http.post(ob, "JsonBrokerServices/find", true).subscribe(
      (x) => {
        let dataRows: any[] = x[this.table_name][0];
        let tableInformation:columnsDef[] = x['table_information'];
        
        let configData:FormConfig[] = userConfig["config"];
        if ( configData != null){

          
          configData.forEach((config: FormConfig) => {
            let col: columnsDef = tableInformation.find(
              (column) => column.COLUMNNAME === config.name
            );
            if (col != null) {
              col.cols = config.colspan == undefined ? 1 : config.colspan;
              col.rows = config.rowspan == undefined ? 1 : config.rowspan;
              col.x = config.x;
              col.y = config.y;
              col.visible =
                config.visible == undefined ? true : config.visible;
              col.tab = config.tab == undefined ? "Geral" : config.tab;
            }
          });
        }

              
        this.integrationRow =  {
          evento:evento,
          row:dataRows,
          tableInformation:x['table_information'],
          userConfig:userConfig
        };//this.item['linha']; 
  
            
        this.dialogServices.openGenericDialog(
          ProdutoInsertEditFormComponent,
          this.integrationRow,
          (popUpData) => {
            
          },
          () => {
          },
          '80vh','100vw',false,null,'S','80px'
        );

      });
  }
  
}

